import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectPlaceholderOld: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userLocationLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userLocationPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectPlaceholderGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectPlaceholderOldGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchPlaceholder: {
		id: 'directories.boards-v2.main.content.filter.search-placeholder',
		defaultMessage: 'Search boards',
		description: 'Placeholder to be displayed for a keyword search feild on boards directory',
	},
	projectPlaceholder: {
		id: 'directories.boards-v2.main.content.filter.project-placeholder',
		defaultMessage: 'Project',
		description: 'Placeholder to be displayed for a project picker on boards directory',
	},
	projectPlaceholderOld: {
		id: 'directories.boards-v2.main.content.filter.project-placeholder-old',
		defaultMessage: 'Select project',
		description: 'Placeholder to be displayed for a project picker on boards directory',
	},
	projectLabel: {
		id: 'directories.boards-v2.main.content.filter.project-label',
		defaultMessage: 'Project',
		description: 'Label to be displayed for a project picker on boards directory',
	},
	userLocationLabel: {
		id: 'directories.boards-v2.main.content.filter.user-label',
		defaultMessage: 'User',
		description: 'Label to be displayed for user picker on boards directory',
	},
	userLocationPlaceholder: {
		id: 'directories.boards-v2.main.content.filter.user-placeholder',
		defaultMessage: 'Select user',
		description: 'Placeholder to be displayed for user picker on boards directory',
	},
	projectPlaceholderGalaxia: {
		id: 'directories.boards-v2.main.content.filter.project-placeholder-galaxia',
		defaultMessage: 'Space',
		description: 'Placeholder to be displayed for a project picker on boards directory',
	},
	projectPlaceholderOldGalaxia: {
		id: 'directories.boards-v2.main.content.filter.project-placeholder-old-galaxia',
		defaultMessage: 'Select space',
		description: 'Placeholder to be displayed for a project picker on boards directory',
	},
});
export default messages;
